// extracted by mini-css-extract-plugin
module.exports = {"Authent":"Authent_Authent__PFFQ5","authbtns":"Authent_authbtns__maLmm"};